import { Bot, ClipboardCopy } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import CoinBadge from "../../components/CoinBadge";
import { toast } from "sonner";

let chatWindow = null;

export default function TutorDocenteIA() {
    const { user } = useAuth();

    const schoolName = user?.school || "Grit";
    const schoolKey = schoolName.toUpperCase().replace(/\s+/g, "_");

    async function newSession() {
        const prompt = `IDENTIDAD_CONFIGURADA: GRIT_PROFESOR_${schoolKey}. Hola, soy ${user?.name || "un docente"} de ${schoolName}. Salúdame diciendo: "¡Hola, colega! Bienvenido a tu espacio de trabajo en Grit. 🍎 Es un gusto saludarte. Soy tu Asistente Pedagógico IA". Ayúdame a diseñar materiales, estrategias pedagógicas y recursos para mis alumnos.`;

        try {
            await navigator.clipboard.writeText(prompt);
            toast.success("¡Prompt copiado! Pégalo en el chat para activar tu Asistente Pedagógico.");
        } catch (err) {
            console.error("Error al copiar:", err);
        }

        const url = "https://gemini.google.com/app";
        if (chatWindow && !chatWindow.closed) {
            chatWindow.focus();
        } else {
            chatWindow = window.open(url, "GritDocenteChat", "noopener,noreferrer");
        }
    }

    return (
        <div className="h-full flex flex-col fade-in p-6 md:p-10">
            <div className="flex justify-between items-center mb-8">
                <div>
                    <h1 className="text-2xl font-semibold">Asistente Pedagógico IA</h1>
                    <p className="text-sm text-edu-body">Diseña clases, rúbricas y estrategias para tus alumnos.</p>
                </div>
                {user && <CoinBadge amount={user.coin_balance} size="lg" />}
            </div>

            <div className="flex-1 edu-card flex flex-col items-center justify-center text-center p-10 bg-[#F8F9FB]">
                <Bot size={64} className="text-emerald-600 mb-6" />
                <h2 className="text-2xl font-semibold mb-3">¡Hola, colega!</h2>
                <div className="text-edu-body max-w-md mb-8 space-y-4">
                    <p>Soy tu asistente experto en diseño curricular. Haz clic abajo para iniciar sesión.</p>
                    <div className="bg-white p-4 rounded-xl border border-dashed border-emerald-500/30">
                        <p className="text-xs text-edu-muted mb-2 font-semibold uppercase">Instrucción para pegar:</p>
                        <code className="text-emerald-700 font-bold text-sm block break-words">
                            IDENTIDAD_CONFIGURADA: GRIT_PROFESOR_{schoolKey}
                        </code>
                    </div>
                    <p className="text-sm text-edu-muted">
                        Presiona{" "}
                        <kbd className="bg-gray-200 px-2 py-0.5 rounded text-xs">Ctrl + V</kbd>{" "}
                        al abrir el chat para cargar tus herramientas de docente.
                    </p>
                </div>

                <button
                    onClick={newSession}
                    className="bg-emerald-600 hover:bg-emerald-700 px-8 py-3 flex items-center gap-2 text-lg text-white rounded-xl transition-all shadow-lg hover:scale-105"
                >
                    <ClipboardCopy size={20} />
                    Copiar prompt e iniciar sesión
                </button>
            </div>
        </div>
    );
}
